(() => {
  const app = name => `[data-essential-preorder-element="back-in-stock-${name}"]`;
  const bell = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9Z"/><path d="M10 21h4M12 1v1"/></svg>';
  let context, queued = false;
  let suggestionsRequest;
  const data = element => {
    try { return JSON.parse(element?.textContent || 'null'); } catch { return null; }
  };
  const selected = (picker, product) => {
    const form = picker ? document.getElementById(picker.getAttribute('form')) : document.querySelector('form[is="product-form"]');
    const id = form?.querySelector('[name="id"]')?.value;
    return product.variants.find(v => String(v.id) === String(id)) || product.variants.find(v => String(v.id) === new URLSearchParams(location.search).get('variant')) || product.variants.find(v => v.available) || product.variants[0];
  };
  function open(picker, product, variant) {
    if (!variant || variant.available) return;
    const mainProduct = data(document.getElementById('vivazz-restock-product'));
    if (!mainProduct || mainProduct.id !== product.id) {
      const root = window.Shopify?.routes?.root || '/';
      location.assign(`${root}products/${product.handle}?variant=${variant.id}&vivazz_restock=1`);
      return;
    }
    context = {product, variant};
    let attempts = 0;
    const launch = () => {
      const trigger = document.querySelector(app('button'));
      const actual = selected(picker, product);
      if (trigger && actual?.id === variant.id && trigger.getBoundingClientRect().width) { trigger.click(); return; }
      if (++attempts < 30) setTimeout(launch, 100);
    };
    setTimeout(launch, 100);
  }
  function decoratePicker(picker) {
    const product = data(picker.querySelector('[data-vivazz-product]'));
    if (!product) return;
    const current = selected(picker, product);
    picker.querySelectorAll('[data-vivazz-size-option]').forEach(field => {
      const position = Number(field.dataset.vivazzSizeOption) - 1;
      field.querySelectorAll('label[data-option-value]').forEach(label => {
        const input = document.getElementById(label.htmlFor);
        if (!input || !current) return;
        const options = current.options.slice();
        options[position] = input.value;
        const variant = product.variants.find(v => v.options.every((value, i) => value === options[i]));
        const unavailable = Boolean(variant && !variant.available);
        label.classList.toggle('vivazz-size-soldout', unavailable);
        let button = label.querySelector('.vivazz-size-bell');
        if (unavailable && !button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'vivazz-size-bell';
          button.innerHTML = bell;
          button.setAttribute('aria-label', `Avise-me quando o tamanho ${input.value} voltar ao estoque`);
          button.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            input.checked = true;
            input.dispatchEvent(new Event('change', {bubbles: true}));
            const chosen = selected(picker, product);
            open(picker, product, chosen);
          });
          label.append(button);
        } else if (!unavailable && button) button.remove();
        if (!variant) label.classList.add('vivazz-size-nonexistent');
        else label.classList.remove('vivazz-size-nonexistent');
      });
    });
  }
  function decorateModal() {
    const modal = document.querySelector(app('pop-up-container'));
    if (!modal || !modal.querySelector(app('pop-up-form'))) return;
    const product = context?.product || data(document.getElementById('vivazz-restock-product'));
    const picker = [...document.querySelectorAll('variant-picker')].find(p => p.getAttribute('handle') === product?.handle);
    const variant = context?.variant || (product && selected(picker, product));
    if (!product || !variant) return;
    modal.classList.add('vivazz-restock-modal');
    let visual = modal.querySelector('.vivazz-restock-visual');
    if (!visual) {
      visual = document.createElement('div');
      visual.className = 'vivazz-restock-visual';
      visual.append(document.createElement('img'));
      modal.prepend(visual);
    }
    const image = visual.querySelector('img');
    const colorVariant = product.variants.find(v => v.option1 === variant.option1 && v.featured_image);
    const src = variant.featured_image?.src || colorVariant?.featured_image?.src || product.featured_image;
    if (src && image.getAttribute('src') !== src) image.src = src;
    image.alt = `${product.title} — ${variant.title}`;
    let detail = modal.querySelector('.vivazz-restock-details');
    if (!detail) {
      detail = document.createElement('div');
      detail.className = 'vivazz-restock-details';
      detail.append(document.createElement('strong'), document.createElement('p'));
      modal.querySelector(app('pop-up-description')).after(detail);
    }
    const text = variant.options.map((value, i) => `${typeof product.options[i] === 'string' ? product.options[i] : product.options[i]?.name}: ${value}`).join(' · ');
    if (detail.querySelector('strong').textContent !== product.title) detail.querySelector('strong').textContent = product.title;
    if (detail.querySelector('p').textContent !== text) detail.querySelector('p').textContent = text;
    modal.querySelector(app('pop-up-close'))?.setAttribute('aria-label', 'Fechar aviso de reposição');
    if (window.matchMedia('(min-width:750px)').matches && !modal.querySelector('.vivazz-restock-recommendations')) {
      if (!suggestionsRequest) {
        const root = window.Shopify?.routes?.root || '/';
        suggestionsRequest = fetch(`${root}?section_id=vivazz-restock-recommendations`, {credentials:'same-origin'})
          .then(response => response.ok ? response.text() : '')
          .then(html => {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            return parsed.querySelector('.vivazz-restock-recommendations');
          }).catch(() => null);
      }
      suggestionsRequest.then(section => {
        if (section?.querySelector('a') && modal.isConnected && !modal.querySelector('.vivazz-restock-recommendations')) {
          const copy = section.cloneNode(true);
          copy.querySelectorAll('a').forEach(link => {
            if (new URL(link.href, location.origin).pathname === `/products/${product.handle}`) link.closest('li').remove();
          });
          if (copy.querySelector('a')) modal.append(copy);
        }
      });
    }
  }
  function update() {
    queued = false;
    document.querySelectorAll('variant-picker').forEach(decoratePicker);
    document.querySelectorAll(app('container')).forEach(container => {
      container.querySelectorAll('.vivazz-restock-status').forEach(status => status.remove());
      const trigger = container.querySelector(app('button'));
      if (trigger?.getAttribute('aria-label') !== 'Esgotado - Avise -me') trigger?.setAttribute('aria-label', 'Esgotado - Avise -me');
    });
    decorateModal();
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(update); } }
  document.addEventListener('variant:change', event => {
    if (context && event.detail?.product?.id === context.product.id) context = null;
    schedule();
  });
  document.addEventListener('click', event => {
    if (event.target.closest(app('button'))) {
      const product = data(document.getElementById('vivazz-restock-product'));
      const picker = [...document.querySelectorAll('variant-picker')].find(p => p.getAttribute('handle') === product?.handle);
      if (product) context = {product, variant: selected(picker, product)};
    }
  }, true);
  new MutationObserver(schedule).observe(document.body, {childList:true, subtree:true});
  update();
  if (new URLSearchParams(location.search).get('vivazz_restock') === '1') {
    const product = data(document.getElementById('vivazz-restock-product'));
    const picker = [...document.querySelectorAll('variant-picker')].find(p => p.getAttribute('handle') === product?.handle);
    if (product) open(picker, product, selected(picker, product));
    const url = new URL(location.href);
    url.searchParams.delete('vivazz_restock');
    history.replaceState(history.state, '', url);
  }
})();

